import store from './store.js'

const Actions = (update$) => {
    return {
        actionExample(obj) {
            const updatedObj = {
                ...store.states$().stateExample,
                ...obj
            }
            update$({ stateExample: updatedObj })
        }
    }
}

export default Actions

